import FastClick from 'fastclick'

// 判断当前是否ios18.2系统
export function curIsIosTenEight() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (userAgent.includes('iOS')) {
    const parts = userAgent.split('|')
    const iosIndex = parts.indexOf('iOS')
    const iosVersion = iosIndex !== -1 ? parts[iosIndex + 1] : null
    const isCompare = compareVersions(iosVersion, '18.2') // 需要大于或等于18.2
    if (isCompare) {
    // 是就开启fastClick
     if (!FastClick.attach) {
        FastClick.attach = function(element) {
            return FastClick(element);
        };
     }
      FastClick.attach(document.body)
      FastClick.prototype.focus = function(targetElement) {
        let length
        if (
          targetElement.setSelectionRange &&
        targetElement.type.indexOf('date') !== 0 &&
        targetElement.type !== 'time' &&
        targetElement.type !== 'month' &&
        targetElement.type !== 'email'
        ) {
          length = targetElement.value.length
          targetElement.focus()
          targetElement.setSelectionRange(length, length)
        } else {
          targetElement.focus()
        }
      }
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

// 比较版本号
export function compareVersions(current, min) {
  if (!current || !min) return false // 如果版本号不存在，返回 false

  const currentParts = current.split('.').map(Number)
  const minParts = min.split('.').map(Number)

  // 逐级比较版本号
  for (let i = 0; i < Math.max(currentParts.length, minParts.length); i++) {
    const currentVal = currentParts[i] || 0
    const minVal = minParts[i] || 0

    if (currentVal > minVal) return true // 当前版本更高
    if (currentVal < minVal) return false // 当前版本更低
  }

  return true // 版本完全相同
}
